<template>
  <div>
    <DocumentsList :dealer-name="true" />
  </div>
</template>

<script>
import DocumentsList from "@/components/documents-list/BuyerDocumentsList"

export default {
  name: "BuyerDocuments",
  components: {
    DocumentsList,
  },
}
</script>

<style scoped></style>
